// frontend/src/ActivityLog/apiClient.js — /api/activity (System › Activity).
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/activity';
async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : ''; } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const qs = (o) => { const p = new URLSearchParams(); Object.entries(o || {}).forEach(([k, v]) => { if (v !== '' && v !== null && v !== undefined) p.set(k, v); }); const s = p.toString(); return s ? `?${s}` : ''; };

export const activityApi = {
  list: (params) => authenticatedFetch(`${BASE}${qs(params)}`).then(jsonOrThrow),
  csv: async (params) => { const r = await authenticatedFetch(`${BASE}.csv${qs(params)}`); if (!r.ok) await jsonOrThrow(r); return r.blob(); },
};
